import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import moment from "moment";
import {store} from "@/plugins/vuex";
import {SYSTEM_DATE_FORMAT} from "../../core/services/formatter.service";

export default class BidderSearch extends BaseModel {
  uuid = null;
  customer_uuid = null;
  paddle_number = null;
  company_name = null;
  sale_no = null;
  negotiation_bidder = false;
  personal_identification_number = null;
  document_type = null;
  document_number = null;
  document_issue_date = {startDate: null, endDate: null};
  document_expiry_date = {startDate: null, endDate: null};
  date_of_birth = {startDate: null, endDate: null};
  citizenship_code = null;
  residency_code = null;
  country_of_birth_code = null;
  place_of_issue = null;
  company_reg_number = null;
  winners = null;
  identity_verification = null;
  kyc_status_verification = null;
  client_tier = null;

  rules = {};

  attributeLabels = {
    uuid: i18n.t('Bidder'),
    customer_uuid: i18n.t('Bidder'),
    paddle_number: i18n.t('Paddle Number'),
    company_name: i18n.t('Company Name'),
    sale_no: i18n.t('Sale'),
    negotiation_bidder: i18n.t('Negotiation Bidder'),
    identity_verification: i18n.t('Identity Verification'),
    kyc_status_verification: i18n.t('Account/KYC Verification'),
    winners: i18n.t('Winners'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.customer;

    if (store.state && store.state.global && store.state.global.identificationFieldsFilters) {
      let identificationFieldsFilters = store.state.global.identificationFieldsFilters.bidders;
      if (identificationFieldsFilters && identificationFieldsFilters.length > 0) {

        data = this.removeIdentificationFields(data, identificationFieldsFilters)
        for (let field of identificationFieldsFilters) {
          if (field.type === 'checkbox') {
            data[field.key] ? data[field.key] = 'true' : delete data[field.key]
          } else if (field.type === "daterange") {
            if (data[field.key].startDate) {
              data[`${field.key}_after`] = moment(data[field.key].startDate).format(SYSTEM_DATE_FORMAT);
              data[`${field.key}_before`] = moment(data[field.key].endDate).format(SYSTEM_DATE_FORMAT);
            }
            delete data[field.key]
          }
        }
      } else {
        data = this.removeIdentificationFields(data, [])
      }
    } else {
      data = this.removeIdentificationFields(data, [])
    }

    if (!this.identity_verification) {
      delete data.identity_verification;
    }

    if (!this.kyc_status_verification) {
      delete data.kyc_status_verification;
    }

    if (!this.winners) {
      delete data.winners;
    }

    return data;
  }

  removeIdentificationFields(data, excludeInRemove = []) {
    const removeFields = [
      'personal_identification_number',
      'document_type',
      'document_number',
      'document_issue_date',
      'document_expiry_date',
      'date_of_birth',
      'citizenship_code',
      'residency_code',
      'country_of_birth_code',
      'place_of_issue',
      'company_reg_number',
    ]
    const fieldKeys = excludeInRemove.map(field => field.key)
    for (const field of removeFields) {
      if (!fieldKeys.includes(field)) {
        delete data[field]
      }
    }
    data.negotiation_bidder ? data.negotiation_bidder = 'true' : delete data.negotiation_bidder

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(BidderSearch);
